import VideoLinkForm from 'components/VideoLinkForm/VideoLinkForm'

export default VideoLinkForm
